<template>
  <div>
    <!--header-->
    <header class="header">
        <nav class="navbar navbar-expand navbar-light navbar-tp">
            <a class="navbar-brand me-auto" href="../../public/index.html"><img src="../images/logo.png" class="logo"></a>
            <div class="navbar-collapse" id="navbarSupportedContent" style="margin-left: 80%;">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item p-0"><a class="logout_btn" @click="logout()">Logout</a></li>
                </ul>
            </div>
        </nav>
    </header>
    <section class="main-proof-work pt-40 pb-40">
        <div class="container-fluid" style="padding:0% 5% 0% 5%!important;">
          <div class="row">
              <div class="col-lg-5 mb-3">
                  <div class="top-title d-flex align-items-center flex-wrap pb-5">
                      <h1 class="fs-32 pe-4 mb-2" style="margin-right: 2%;">Proof of Work</h1>
                      <button class="start_btn mb-2" v-if="isClicked == true" type="primary" @click="btnStartRecording"><i class="clock-icn"></i> Start Job</button>
                      <button class="start_btn mb-2" v-if="isClicked == false" type="primary" @click="btnstopRecording"><i class="clock-icn"></i> Stop Job</button>
                  </div>
                  <div class="video_scn">
                      <h2 class="fs-24 pb-2 pb-lg-4">Job Recording</h2>
                      <div class="record_video">
                          <video controls autoplay playsinline style="width: 100%;"></video>
                          <!-- <a class="mediabox d-inline-block" href="https://youtu.be/B10qMSIDCek">
                              <img src="../images/video-banner.png" class="img-fluid" alt="">
                          </a> -->
                      </div>
                  </div>
              </div>
              <div class="col-lg-7 mb-3">
                  <div class="right_scn">
                      <div class="top-date d-flex align-items-center flex-wrap justify-content-lg-end pb-5">
                          <button class="refresh_btn me-3 mb-2 mr-4" @click="refresh"><i class="fa fa-refresh"></i> Refresh Date</button>
                          <div class="date_view mb-2">
                              <div class="date_list position-relative" style="margin-right: 3%;">
                                  <!-- <DatePicker class="form-control" type="daterange" v-model="selectedDate" placement="bottom-end" placeholder="Select date" style="width: 300px"></DatePicker> -->
                                  <input type="date" class="form-control" id="startDate" v-model="startDate" :max="maxDate">
                                  <span class="line_txt">-</span>
                                  <input type="date" class="form-control" id="endDate" v-model="endDate" :max="maxDate">
                              </div>
                              <button class="filter_btn" @click="filterData">Filter</button>
                          </div>
                      </div>
                      <div >
                          <h2 class="fs-24 pb-2 pb-lg-4">Job Screenshots</h2>
                          <!-- <table id="table" data-show-toggle="True" :columns="columns1" :data="data1" data-maintain-selected="true" data-pagination="true" class="table table-striped"></table> -->
                          <div>
                            <div class="datatable-main">
                              <!-- Main table element -->
                              <b-table class="table datatable-cstm" hover :items="data1" :fields="columns1" :current-page="currentPage" :per-page="perPage" :filter="filter">
                                <template #cell(createdAt)="data">
                                  {{ data.item.createdAt | changeDate}}
                                </template>
                                <template #cell(updatedAt)="data">
                                  <span v-if="id === data.item._id && isClicked == false">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ data.item.updatedAt | changeDate}}
                                  </span>
                                </template>
                              </b-table>

                              <div class="justify-content-centermy-1 row" style="text-align:right;">
                                <b-form-fieldset horizontal class="col-10" :label-size="6">
                                <b-pagination size="md" :total-rows="this.data1.length" :per-page="perPage" v-model="currentPage" />
                                </b-form-fieldset>
                                <b-form-fieldset horizontal lableclass="col-2" style="padding-top: 1%;" :label-size="6">
                                  <b-form-select :options="[{text:5,value:5},{text:10,value:10},{text:15,value:15}]" v-model="perPage">
                                  </b-form-select>
                                </b-form-fieldset>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </section>
  </div>
    <!-- <video id="abc" controls autoplay playsinline style="width: 50%;"></video> -->
</template>
/* eslint-disable */
<script>

// const RecordRTC = require("recordrtc");
const endeFrame = require("../myjs/index");
const objRSA = endeFrame.getRSA();
const AWS = require("aws-sdk");
const moment = require("moment");
import _ from 'lodash'
import { RecordRTC } from '../javascript/RecordRTC.js'
import axios from "axios";
import Cookies from "js-cookie";
import jobdetails from "../api/jobdetails";
import pyextraction from "../api/pyextraction";
import { rejects } from 'assert';
import { async, Promise } from 'q';
import { constants } from 'fs';

const CryptoJS = require("crypto-js");
var forge = require('node-forge');

AWS.config.update({
  accessKeyId: process.env.VUE_APP_ACCESSKEY, //process.env.accesskey,
  secretAccessKey: process.env.VUE_APP_SECRETKEY //process.env.secretkey
});
AWS.config.region = "ap-south-1";

export default {
  name: "Record",
  data() {
    return {
      currentPage: 1,
      perPage: 5,
      filter: null,
      stopFlag: true,
      startDate: moment(Date()).format('YYYY-MM-DD'),
      endDate: moment(Date()).format('YYYY-MM-DD'),
      maxDate: moment(Date()).format('YYYY-MM-DD'),
      selectedDate: [],
      oldData: [],
      initialFlag: false,
      today1: "",
      id: "",
      recorder: null,
      browserName: "",
      operatingSystem: "",
      isClicked: true,
      videoSrc: null,
      columns1: [
        {
          label: "Job Id",
          key: "_id"
        },
        {
          key: "createdAt",
          label: "Job Start"
        },
        {
          label: "Job End",
          key: "updatedAt"
        }
      ],
      data1: [],
      counter: 0,
      frame: null,
      frame2: null,
      customerPublicKey : null,
      customerPrivateKey : null,
      enc1: null,
      enc2: null,
      key: null,
      cameraFound: false,
      RECORDING_INTERVAL : process.env.VUE_APP_RECORDING_INTERVAL != undefined ? process.env.VUE_APP_RECORDING_INTERVAL : 10000
      // params.row.updatedAt !== undefined ? h('span', moment(params.row.updatedAt).format('DD/MM/YYYY h:mm:ss a')) : h('span', '')
      // process.env.VUE_APP_RECORDING_INTERVAL != undefined ? process.env.VUE_APP_RECORDING_INTERVAL : 10
      // make_file: false
    };
  },
  filters: {
    changeDate(val) {
      return moment(val).format('DD/MM/YYYY h:mm:ss a')
    }
  },
  watch: {
    frame2: async function(frame) {
      let self = this
      // console.log('watcher start')
      console.log("before changed:",this.today1.format('DD/MM/YYYY h:mm:ss a'))

  
      // console.log(self.blob)
      // console.log(self.blob.size)      
      // console.log(this.videoSrc)
      // console.log(blob)
      
      this.counter+=1
      console.log('Total frames creates:',this.counter)
      // console.info('New 1 minute video created!!')

      let headers = {
        "Content-Type": "application/json",
        Authorization: Cookies.get("auth_token")
      };
      await jobdetails
      .get(Cookies.get("userId"))
      .then(function(response) {
        // console.log(response.data.data)
        self.data1 = response.data.data;
        if (self.data1.some(item => item.updatedAt === undefined)) {
          self.isClicked = false;
          self.id = self.data1[0]._id;
        } else {
          self.isClicked = true;
        }
        let video_data = {
          'frames': self.counter
        }
        jobdetails
          .patch(self.id, headers, video_data)
          .then(function(response) {
            jobdetails
              .get(Cookies.get("userId"))
              .then(function(response) {
                // console.log(response.data.data)
                self.data1 = response.data.data;
                if (self.data1.some(item => item.updatedAt === undefined)) {
                  self.isClicked = false;
                  self.id = self.data1[0]._id;
                } else {
                  self.isClicked = true;
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          })
          .catch(function(error) {
            console.log(error);
          });
      })
      .catch(function(error) {
        console.log(error);
      });

      // console.log("After changed:",this.today1.add(5, 'seconds').format('DD/MM/YYYY h:mm:ss a'))

      // let enMsg = endeFrame.encryptFrame(frame, endeFrame.getPublicKey(objRSA))
      // console.log('enc size:',enMsg.length)

      // this.encrypt(this.id, this.today1.format("x"), blob, Cookies.get('userId'));

      // this.encrypt(this.id, this.today1.add(5, 'seconds').format('DD/MM/YYYY h:mm:ss'), frame, Cookies.get('userId'), this.counter);

      this.encrypt(this.id, this.today1.add(self.RECORDING_INTERVAL, 'milliseconds').format('x'), frame, Cookies.get('userId'), this.counter);

      // this.today1.add(moment().diff(this.today1, 'seconds'), 'seconds');
      // let newTime = this.today1.add(moment().diff(this.today1, 'seconds'), 'seconds');
      console.log("After changes time",this.today1.format('DD/MM/YYYY h:mm:ss'))

      // self.blob = null


      /* this.extractFramesFromVideo(blob, newTime);

      console.log("Total frames uploaded:",this.frames_counter)
      console.log("Total frames:",this.counter) */

      // this.extractFramesFromVideo(blob, newTime);
      // this.video2frame(blob, newTime);
      // console.log('watcher end')
    }
  },
  methods: {
    initialObject() {
      // console.log(this.initialFlag)
      if (this.initialFlag) this.btnStartRecording();
      // this.initialStartRecording()
      else this.initialStartRecording();
    },
    async logout() {
      let self = this

      
      if (self.recorder !== null && self.recorder.getState() == 'recording')
        self.recorder.stopRecording();

      let headers = {
        "Content-Type": "application/json",
        'from_client' : true,
        Authorization: Cookies.get("auth_token")
      };
      await jobdetails
        .get(Cookies.get("userId"))
        .then(function(response) {
          // console.log(response.data.data)
          self.data1 = response.data.data;
          // console.log(">>>>>>>>>>>>>>", self.data1.some(item => item.updatedAt === undefined))
          // console.log(">>>>>>>>>>>>>>>>>>>",self.data1[0]._id)
          if (self.data1.some(item => item.updatedAt === undefined)) {
            self.isClicked = false;
            self.id = self.data1[0]._id;          

            jobdetails
              .patch(self.id, headers)
              .then(function(response) {
                // console.log("res:",response.data)
                // console.log("res",response.data.createdAt)
                // console.log("res",response.data.updatedAt)
              })
              .catch(function(error) {
                console.log(error);
              });
          } else {
            self.isClicked = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      // [screen, camera].forEach(function(stream) {
      //     stream.getTracks().forEach(function(track) {
      //         track.stop();
      //     });
      // });

      // self.stream.getTracks().forEach(function(track) {
      //   track.stop();
      // });

      
      
      // self.recorder.destroy();
      // self.recorder = null;
      Cookies.remove("auth_token");
      Cookies.remove("userId");
      this.$router.push({
        name: "login"
      });
    },
    async filterData () {
      let self = this
      let temp = []
      self.data1 = _.cloneDeep(this.oldData)
      if (this.startDate !== '' && this.endDate !== '') {
        await _.filter(self.data1, (item, key) => {
          if (new Date(this.startDate) <= new Date(item.createdAt) && new Date(this.endDate) >= new Date(item.createdAt)) {
            temp.push(item)
          }
        })
        self.data1 = _.cloneDeep(temp)
      }
    },
    refresh() {
      let self = this;
      jobdetails
        .get(Cookies.get("userId"))
        .then(function(response) {
          // console.log(response.data.data)
          self.data1 = response.data.data;
          // console.log(">>>>>>>>>>>>>>", self.data1.some(item => item.updatedAt === undefined))
          // console.log(">>>>>>>>>>>>>>>>>>>",self.data1[0]._id)
          if (self.data1.some(item => item.updatedAt === undefined)) {
            self.isClicked = false;
            self.id = self.data1[0]._id;
            // console.log(self.id)
          } else {
            self.isClicked = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    invokeGetDisplayMedia(success, error) {
      var displaymediastreamconstraints = {
        video: {
          displaySurface: "monitor", // monitor, window, application, browser
          logicalSurface: false,
          cursor: "always" // never, always, motion
        }
      };
      // above constraints are NOT supported YET
      // that's why overridnig them
      displaymediastreamconstraints = {
        video: true
        // video: {
        //     frameRate: 1
        // }
      };
      // console.log(displaymediastreamconstraints);
      // console.log(navigator)
      if (navigator.mediaDevices.getDisplayMedia) {
        console.log('in if')
        navigator.mediaDevices
          .getDisplayMedia(displaymediastreamconstraints)
          .then(success)
          .catch(error);
      } else {
        console.log('in else')
        navigator
          .getDisplayMedia(displaymediastreamconstraints)
          .then(success)
          .catch(error);
      }
    },
    addStreamStopListener(stream, callback) {
      stream.addEventListener(
        "ended",
        function() {
          callback();
          callback = function() {};
        },
        false
      );
      stream.addEventListener(
        "inactive",
        function() {
          callback();
          callback = function() {};
        },
        false
      );
      stream.getTracks().forEach(function(track) {
        track.addEventListener(
          "ended",
          function() {
            callback();
            callback = function() {};
          },
          false
        );
        track.addEventListener(
          "inactive",
          function() {
            callback();
            callback = function() {};
          },
          false
        );
      });
    },
    captureScreen(callback) {
      let self = this;
      self.invokeGetDisplayMedia(
        function(screen) {
          if (self.browserName == "Chrome") {
            if (
              screen.getTracks()[0].getSettings().displaySurface != "monitor"
            ) {
              // alert('Please select the entire screen option.')
              // self.initialFlag = false
              throw new Error("Please select the entire screen option.")
              // throw "Please select the entire screen option.";
            }
          }

          if (self.browserName == "Firefox") {
            if (
              screen.getTracks()[0].getSettings().width !=
                window.screen.width ||
              screen.getTracks()[0].getSettings().height != window.screen.height
            ) {
              // alert('Please select the entire screen option.')
              // self.initialFlag = false
              throw new Error("Please select the entire screen option.")
              // throw "Please select the entire screen option.";
            }
          }

          // console.log(screen.getTracks());
          // console.log(screen.getTracks()[0].getSettings());
          // console.log(screen.getTracks()[0].getSettings().height);
          // console.log(screen.getTracks()[0].getSettings().width);
          // console.log(screen.getTracks()[0].getSettings().label);
          // // console.log(screen.getTracks()[0].getCapabilities())
          // console.log(screen.getTracks()[0].getConstraints());
          // console.log(screen.getTracks()[0].getSettings().displaySurface);

          self.addStreamStopListener(screen, function() {
            if (window.stopCallback) {
              window.stopCallback();
            }
          });
          callback(screen);
          // console.log(screen)
          // console.log(self.initialFlag)

          // self.initialFlag = true;
          // self.isClicked = false;

          

          // console.log('Initial flag in invoke media box',self.initialFlag)
        },
        function(error) {
          console.error(error);



          // if(self.operatingSystem === "Mac OS" && error === "NotAllowedError: Permission denied by system"){
          if(self.operatingSystem === "Mac OS" && error.message.includes("Permission denied by system")){
            alert("Check System Preferences > Security & Privacy > Privacy > Screen Recording. \nMake sure Chrome is listed and is checked.")
          }
          else if (self.browserName == "Firefox")
            alert("Unable to capture your screen.\n" + "Please refresh the page and start the job again.")
          else
            alert(
              "Unable to capture your screen.\n" +
                error +
                "\nPlease start the job again."
            );

          // if (self.browserName == "Firefox")
          //   location.reload()

          // self.initialFlag = false;
          // self.isClicked = true;

          // console.log(self.initialFlag)
        }
      );
    },
    captureCamera(cb) {
      // console.log("capture camera start - succeed!")
      navigator.mediaDevices
        .getUserMedia({ audio: false,
          // video: {frameRate:1}
         video: true
          })
        // .then(cb => console.log(">>>>>>CVB",cb));
        .then(cb)
        // .then(() => {
        //   self.cameraFound = true
        //   console.log('camera found',self.cameraFound)
        //   cb.call()
        // })
        .catch(function(error){
          console.log(error)
          // console.log(error.code)
          // console.log(error.name)
          // console.log(error.message)

          if (error.name == 'NotFoundError') {
            self.cameraFound = false
            // console.log('in exception if')
            cb.call()
          }
          else{
            alert(
              "Unable to capture your webcam.\n" +
                error.message +
                "\nPlease allow the camera permission and start the job again."
            );
          }
          // location.reload()
        })
        // console.log("capture camera end - succeed!")
    },
    keepStreamActive(stream) {
      let video = document.createElement("video");
      video.muted = true;
      video.srcObject = stream;
      video.style.display = "none";
      (document.body || document.documentElement).appendChild(video);
      // console.log("keep stream alive - succeed!")
    },
    
    async btnStartRecording() {
      let self = this;
      // self.isClicked = false;
      // console.log("in start");
      // console.log("recording interval:",self.RECORDING_INTERVAL)
      // console.log(process.env.VUE_APP_RECORDING_INTERVAL)
      self.stopFlag = false;
      self.counter=0
      
      
      self.captureScreen(async function(screen) {
        self.keepStreamActive(screen);
        self.captureCamera(async function(camera) {
          self.keepStreamActive(camera);

          // console.log(window.screen.width);
          // console.log(window.screen.height);
          // console.log('userId:',Cookies.get("userId"))
          let headers = {
            "Content-Type": "application/json",
            Authorization: Cookies.get("auth_token"),
            userId: Cookies.get("userId")
          };
          await jobdetails
            .post({'emailID': Cookies.get('emailId')}, headers)
            .then(function(response) {
              // console.log("res",response)
              // today = new Date(response.data.data[1].createdAt)
              self.today1 = moment.parseZone(response.data.createdAt);
              self.id = response.data._id;
              jobdetails
                .get(Cookies.get("userId"))
                .then(function(response) {
                  // console.log(response.data.data)
                  self.data1 = response.data.data;
                  if (self.data1.some(item => item.updatedAt === undefined)) {
                    self.isClicked = false;
                    self.id = self.data1[0]._id;
                  } else {
                    self.isClicked = true;
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
              // self.setStartRecoding();
            })
            .catch(function(error) {
              console.log("Error Posting data to mongo", error);
            });

          // console.log('camera',self.cameraFound)

          let devices = []

          screen.width = window.screen.width;
          screen.height = window.screen.height;
          screen.fullcanvas = true;

          // if (self.cameraFound == true) {
          //   camera.width = 320;
          //   camera.height = 240;
          //   camera.top = screen.height - camera.height;
          //   camera.left = screen.width - camera.width;
          //   devices = [screen, camera]
          // }
          // else
          //   devices = [screen]

          // camera.width = 320;
          // camera.height = 240;
          // camera.top = screen.height - camera.height;
          // camera.left = screen.width - camera.width;
          // devices = [screen, camera]

          try {
            // console.log('in try')
            camera.width = 320;
            camera.height = 240;
            camera.top = screen.height - camera.height;
            camera.left = screen.width - camera.width;
            devices = [screen, camera]
            // console.log('in try 2')
          } catch (error) {
            console.log(error)
            // console.log('in catch')
            devices = [screen]
          }

          

          self.recorder = RecordRTC(devices, {
            type: "video",
            disableLogs: true,
            // mimeType: "video/webm",
            webmmimeType: 'video/webm;codecs=vp9',
            frameInterval: 1000,
            // videoBitsPerSecond: 5242880,
            // timeSlice: 2000,
            previewStream: function(s) {
              document.querySelector("video").muted = true;
              document.querySelector("video").srcObject = s;
            },

          });

          var recorder2 = self.recorder.startRecording().record()

          var refreshIntervalId = setInterval(async function(){
              // console.log('============================================')
              // console.log(self.recorder === null)
              // console.log(self.recorder.getState())
              // console.log(self.recorder)
              if (self.recorder === null || self.recorder.getState() == 'stopped'){
                  // console.log('in stopped')
                  // clearInterval(refreshIntervalId._id);
                  
                  clearInterval(refreshIntervalId);
                  devices.forEach(function(stream) {
                      stream.getTracks().forEach(function(track) {
                          track.stop();
                      });
                  });
              }
              else {
                  self.frame = recorder2.drawVideosToCanvas2()
                  // console.log('frame when recording:',self.frame.length)
                  if (self.frame !== null && self.frame !== undefined){
                    // self.frame2 = self.frame
                    self.changed(self.frame)
                    // self.counter+=1
                    // console.log('Total frames creates:',self.counter)
                  }
              }
              // if (self.recorder === null){
              //     console.log('in stopped')
              //     clearInterval(refreshIntervalId._id);
              // }
              
              // clearInterval(refreshIntervalId);

          // }, 10000)
          }, self.RECORDING_INTERVAL)

        });

      });

    },

    async changed(frame) {
      let self = this
      // console.log('watcher start')
      // console.log("before changed:",self.today1.format('DD/MM/YYYY h:mm:ss a'))

  
      // console.log(self.blob)
      // console.log(self.blob.size)      
      // console.log(this.videoSrc)
      // console.log(blob)
      
      this.counter+=1
      // console.log('Total frames creates:',this.counter)
      // console.info('New 1 minute video created!!')

      let headers = {
        "Content-Type": "application/json",
        Authorization: Cookies.get("auth_token")
      };
      jobdetails
      .get(Cookies.get("userId"))
      .then(function(response) {
        // console.log(response.data.data)
        self.data1 = response.data.data;
        if (self.data1.some(item => item.updatedAt === undefined)) {
          self.isClicked = false;
          self.id = self.data1[0]._id;
        } else {
          self.isClicked = true;
        }
        let video_data = {
          'frames': self.counter
        }
        jobdetails
          .patch(self.id, headers, video_data)
          .then(function(response) {
            jobdetails
              .get(Cookies.get("userId"))
              .then(function(response) {
                // console.log(response.data.data)
                self.data1 = response.data.data;
                if (self.data1.some(item => item.updatedAt === undefined)) {
                  self.isClicked = false;
                  self.id = self.data1[0]._id;
                } else {
                  self.isClicked = true;
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          })
          .catch(function(error) {
            console.log(error);
          });
      })
      .catch(function(error) {
        console.log(error);
      });

      // console.log("After changed:",this.today1.add(5, 'seconds').format('DD/MM/YYYY h:mm:ss a'))

      // let enMsg = endeFrame.encryptFrame(frame, endeFrame.getPublicKey(objRSA))
      // console.log('enc size:',enMsg.length)

      // this.encrypt(this.id, this.today1.format("x"), blob, Cookies.get('userId'));

      // this.encrypt(this.id, this.today1.add(5, 'seconds').format('DD/MM/YYYY h:mm:ss'), frame, Cookies.get('userId'), this.counter);

      this.encrypt(this.id, this.today1.add(self.RECORDING_INTERVAL, 'milliseconds').format('x'), frame, Cookies.get('userId'), this.counter);

      // this.today1.add(moment().diff(this.today1, 'seconds'), 'seconds');
      // let newTime = this.today1.add(moment().diff(this.today1, 'seconds'), 'seconds');
      
      // console.log("After changes time",this.today1.format('DD/MM/YYYY h:mm:ss'))

      // self.blob = null


      /* this.extractFramesFromVideo(blob, newTime);

      console.log("Total frames uploaded:",this.frames_counter)
      console.log("Total frames:",this.counter) */

      // this.extractFramesFromVideo(blob, newTime);
      // this.video2frame(blob, newTime);
      // console.log('watcher end')
    },

    async btnstopRecording() {
      let self = this;
      self.isClicked = true;
      self.stopFlag = true;

      
      // console.log("in stop");

      // console.log(self.recorder !== null)
      // console.log(self.recorder.getState())

      if (self.recorder !== null){
        self.recorder.stopRecording();
      }
      // console.log('Total frames creates:',self.counter)
        

      let headers = {
        "Content-Type": "application/json",
        'from_client' : true,
        Authorization: Cookies.get("auth_token")
      };
      await jobdetails
        .patch(self.id, headers)
        .then(function(response) {
          // console.log("res:",response.data)
          // console.log("res",response.data.createdAt)
          // console.log("res",response.data.updatedAt)
          jobdetails
            .get(Cookies.get("userId"))
            .then(function(response) {
              // console.log(response.data.data)
              self.data1 = response.data.data;
              if (self.data1.some(item => item.updatedAt === undefined)) {
                self.isClicked = false;
                self.id = self.data1[0]._id;
              } else {
                self.isClicked = true;
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(function(error) {
          console.log(error);
        });
      // console.log("button stop recording stopflag:",self.stopFlag)

      // self.recorder.stopRecording();

    },


    encrypt(id, today, file, userId, video_counter) {
      // return new Promise((resolve, reject)=>{
        // // console.log("enc",today)
        // this.customerPublicKey = endeFrame.getPublicKey(objRSA)
        // console.log(this.customerPublicKey)
        // console.log('frame length:',file.length)
        // this.enc1 = 'abcd'
        // file = 'abcd'
        // let enMsg = endeFrame.encryptFrame(file, endeFrame.getPublicKey(objRSA))
        // console.log('encryption size:',enMsg.length)

        // var a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style = "display: none";

        // var url = enMsg;
        // a.href = url;
        // a.download = 'download';
        // a.click();
        // window.URL.revokeObjectURL(url);

        // this.decrypt(enMsg, today);
        if (userId !== undefined) {
          this.uploadFile(id, today, file, userId, video_counter)
          console.log("encrypt called!");
        }
        // this.uploadToPython(id, today, file, userId, video_counter);

        // this.encrypt_aes_cryptoJS(id, today, file, userId, video_counter)
        // this.encrypt_aes_webCrypto(id, today, file, userId, video_counter)
        // this.encrypt_aes__forge(id, today, file, userId, video_counter)
        // this.encrypt_rsa_webCrypto(id, today, file, userId, video_counter)
      // });
    },

    encrypt_aes_cryptoJS(id, today, file, userId, video_counter){
      let secretKey = '123456'
      console.log('Original data:',file.length)

      this.uploadFile(id, today, file, userId, video_counter)

      var t0 = performance.now();

      var enc_data = CryptoJS.AES.encrypt(file, secretKey).toString()
      
      var t1 = performance.now();
      console.log("Time taken: " + (t1 - t0) + " milliseconds.");
      

      console.log('Encrypted data:',enc_data.length)
      // console.log('key:',enc_data.key)

      var bytes  = CryptoJS.AES.decrypt(enc_data, secretKey);
      var originalText = bytes.toString(CryptoJS.enc.Utf8);
      console.log('Decrypted data:',originalText.length)

      // this.uploadFile(id, today+'(1)', originalText, userId, video_counter)
    },

    encrypt_aes_webCrypto(id, today, file, userId, video_counter){
      let self = this
      console.log('Original data:',file.length)

      // self.uploadFile(id, today, file, userId, video_counter)

      let ab = window.crypto.getRandomValues(new Uint8Array(16))
      
      window.crypto.subtle.generateKey({
            name: "AES-CBC",
            length: 256, //can be  128, 192, or 256
        },
        true, //whether the key is extractable (i.e. can be used in exportKey)
        ["encrypt", "decrypt"] //can be "encrypt", "decrypt", "wrapKey", or "unwrapKey"
    )
    .then(function(key) {

      window.crypto.subtle.exportKey(
          "raw", //can be "jwk" or "raw"
          key //extractable must be true
      )
      .then(function(keydata){
          //returns the exported key data

          console.log(keydata);
          console.log(typeof keydata);

          // var kd = keydata

          window.crypto.subtle.importKey(
            "raw", //can be "jwk" or "raw"
            keydata,
            {   //this is the algorithm options
                name: "AES-CBC",
            },
            false, //whether the key is extractable (i.e. can be used in exportKey)
            ["encrypt", "decrypt"] //can be "encrypt", "decrypt", "wrapKey", or "unwrapKey"
        )
        .then(function(key2){
            //returns the symmetric key
            console.log(key2);

            console.log("our key:");
            console.log(key2);

            var t0 = performance.now();

            window.crypto.subtle.encrypt({
                        name: "AES-CBC",
                        //Don't re-use initialization vectors!
                        //Always generate a new iv every time your encrypt!
                        iv: window.crypto.getRandomValues(new Uint8Array(32)),
                    },
                    key, //from generateKey or importKey above
                    self.stringToArrayBuffer(file) //ArrayBuffer of data you want to encrypt
                )
                .then(function(encrypted) {

                    var t1 = performance.now();
                    console.log("Time taken: " + (t1 - t0) + " milliseconds.");

                    //returns an ArrayBuffer containing the encrypted data
                    console.log("our ciphertext:");
                    let enc = new Uint8Array(encrypted)
                    console.log('Encrypted data:',enc.length)
                    self.uploadFile(id, today+'(1)', self.arrayBufferToString(new Uint8Array(encrypted)), userId, video_counter)

                    window.crypto.subtle.decrypt(
                        {
                            name: "AES-CBC",
                            iv: new ArrayBuffer(32), //The initialization vector you used to encrypt
                        },
                        key, //from generateKey or importKey above
                        new Uint8Array(encrypted) //ArrayBuffer of the data
                    )
                    .then(function(decrypted){
                        //returns an ArrayBuffer containing the decrypted data

                        // let dec = self.uintToString(new Uint8Array(decrypted))

                        let dec = self.arrayBufferToString(new Uint8Array(decrypted))
                        console.log('Decrypted data:',dec.length);
                        // console.log('check',file===dec)
                        // self.uploadFile(id, today+'(1)', dec, userId, video_counter)
                    })
                    .catch(function(err){
                        console.error(err);
                    });
            
        })
        .catch(function(err){
            console.error(err);
        });


      })
      .catch(function(err){
          console.error(err);
      });

      


        //returns a key object
        // console.log("our key:");
        // console.log(key);

        // var t0 = performance.now();

        // window.crypto.subtle.encrypt({
        //             name: "AES-CBC",
        //             //Don't re-use initialization vectors!
        //             //Always generate a new iv every time your encrypt!
        //             iv: window.crypto.getRandomValues(new Uint8Array(16)),
        //         },
        //         key, //from generateKey or importKey above
        //         self.stringToArrayBuffer(file) //ArrayBuffer of data you want to encrypt
        //     )
        //     .then(function(encrypted) {

        //         var t1 = performance.now();
        //         console.log("Time taken: " + (t1 - t0) + " milliseconds.");

        //         //returns an ArrayBuffer containing the encrypted data
        //         console.log("our ciphertext:");
        //         let enc = new Uint8Array(encrypted)
        //         console.log('Encrypted data:',enc.length)

        //         window.crypto.subtle.decrypt(
        //             {
        //                 name: "AES-CBC",
        //                 iv: new ArrayBuffer(16), //The initialization vector you used to encrypt
        //             },
        //             key, //from generateKey or importKey above
        //             new Uint8Array(encrypted) //ArrayBuffer of the data
        //         )
        //         .then(function(decrypted){
        //             //returns an ArrayBuffer containing the decrypted data

        //             // let dec = self.uintToString(new Uint8Array(decrypted))

        //             let dec = self.arrayBufferToString(new Uint8Array(decrypted))
        //             console.log('Decrypted data:',dec.length);
        //             // console.log('check',file===dec)
        //             // self.uploadFile(id, today+'(1)', dec, userId, video_counter)
        //         })
        //         .catch(function(err){
        //             console.error(err);
        //         });


            })
            .catch(function(err) {
                console.error(err);
            });

            

    })
    .catch(function(err) {
        console.error(err);
    });

    },

    encrypt_rsa_webCrypto(id, today, file, userId, video_counter){
      let self = this
      console.log('Original data:',file.length)

      window.crypto.subtle.generateKey(
          {
              name: "RSA-OAEP",
              modulusLength: 4096, //can be 1024, 2048, or 4096
              publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
              hash: {name: "SHA-1"}, //can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
          },
          false, //whether the key is extractable (i.e. can be used in exportKey)
          ["encrypt", "decrypt"] //must be ["encrypt", "decrypt"] or ["wrapKey", "unwrapKey"]
      )
      .then(function(key){
          //returns a keypair object
          console.log(key);
          console.log(key.publicKey);
          console.log(key.privateKey);


          window.crypto.subtle.encrypt(
              {
                  name: "RSA-OAEP",
                  //label: Uint8Array([...]) //optional
              },
              key.publicKey, //from generateKey or importKey above
              self.stringToArrayBuffer(file) //ArrayBuffer of data you want to encrypt
          )
          .then(function(encrypted){
              //returns an ArrayBuffer containing the encrypted data
              console.log(new Uint8Array(encrypted));
              // let enc = new Uint8Array(encrypted)
              // console.log('Encrypted data:',enc.length)
          })
          .catch(function(err){
              console.error(err);
          });


      })
      .catch(function(err){
          console.error(err);
      });

    },

    encrypt_aes__forge(id, today, file, userId, video_counter){
      console.log('Original data:',file.length)
      var key = forge.random.getBytesSync(16);
      var iv = forge.random.getBytesSync(16);

      this.uploadFile(id, today, file, userId, video_counter)

      var t0 = performance.now();

      var cipher = forge.cipher.createCipher('AES-CBC', key);
      cipher.start({iv: iv});
      cipher.update(forge.util.createBuffer(file));
      cipher.finish();

      var t1 = performance.now();
      console.log("Time taken: " + (t1 - t0) + " milliseconds.");

      var encrypted = cipher.output;
      // outputs encrypted hex
      // console.log(encrypted.toHex());
      console.log('Encrypted data:',encrypted.toHex().length)

      

      var decipher = forge.cipher.createDecipher('AES-CBC', key);
      decipher.start({iv: iv});
      decipher.update(encrypted);
      var result = decipher.finish(); // check 'result' for true/false
      // outputs decrypted hex
      // console.log(decipher.output.toHex());
      console.log('Decrypted data:',decipher.output.data.length);
      this.uploadFile(id, today+'(1)', decipher.output.data, userId, video_counter)
    },

    stringToArrayBuffer(str) {
        var buf = new ArrayBuffer(str.length);
        var bufView = new Uint8Array(buf);
        for (var i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    },

    arrayBufferToString(str) {
        var byteArray = new Uint8Array(str);
        var byteString = '';
        for (var i = 0; i < byteArray.byteLength; i++) {
            byteString += String.fromCodePoint(byteArray[i]);
            // byteString += byteArray[i];
        }
        console.log(typeof byteString)
        return byteString;
    },
    uintToString(uintArray) {
        var encodedString = String.fromCharCode.apply(null, uintArray),
            decodedString = decodeURIComponent(escape(encodedString));
        return decodedString;
    },

    decrypt(file, name) {
      // this.customerPrivateKey = endeFrame.getPrivateKey(objRSA)

      this.enc2 = endeFrame.decryptFrame(file, endeFrame.getPrivateKey(objRSA));
      console.log(this.enc1===this.enc2)
      
      

      // var image = new Image();
      // image.src = dnMsg;
      // document.body.appendChild(image);
      // this.uploadFile(dnMsg)
    },

    uploadFile(id, name, file, userId, video_counter) {
      let bucket = new AWS.S3({
        params: { Bucket: "customer-frames/frames/" + userId + "/" + id }
      });
      var params = {
        Key: name ,
        Body: file,
        ContentType: file.type,

        // Encryption code which requires keyId(AWS Key Management Service (AWS KMS))
        // InventoryConfiguration: { /* required */
        //   Destination: { /* required */
        //     S3BucketDestination: { /* required */
        //       Bucket: bucket, /* required */
        //       Format: CSV | ORC | Parquet, /* required */
        //       Encryption: {
        //         SSEKMS: {
        //           KeyId: 'STRING_VALUE' /* required */
        //         },
        //         SSES3: {
        //         }
        //       },
        //       Prefix: 'STRING_VALUE'
        //     }
        //   },
        // }


        // ContentEncoding: "utf-8",
        // ContentType: "text/csv;charset utf-8"
      };
      bucket
        .upload(params)
        .send(function(err, data) {
          if (err) {
            alert(err);
            reject(err);
          } else {
            // console.log(id+'_'+video_counter, "Uploaded!");
            console.log(id, "Uploaded!");
            // resolve(data.Location)
          }
        });
    },

    uploadToPython(id, name, blob, userId, video_counter) {
      let self = this;

      // console.log(blob)
      console.log(blob.length)

      // self.total_blob_size += blob.length

      // console.log(self.total_blob_size)

      // console.log(self.recorder.getState())

      // if (self.recorder.getState() != 'recording')
      //   self.recording_stopped = true
      // else
      //   self.recording_stopped = false


      // var file = new File([blob], 'testVideo.webm');

      let headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      }

      let bodyFormData = new FormData();
      bodyFormData.append("base64_img", blob);
      bodyFormData.append("id", id);
      bodyFormData.append("name", name);
      bodyFormData.append('userId', userId);
      // bodyFormData.append('auth_token', Cookies.get('auth_token'))
      // bodyFormData.append('recording_stopped', self.recording_stopped);
      // bodyFormData.append('video_counter', video_counter);
      // console.log("hi",bodyFormData)
      // for (var key of bodyFormData.entries()) {
      //   console.log(key[0] + ', ' + key[1]);
      // }
      // let json_data = {
      //   file : blob,
      //   id : id

      // }
      // console.log(json_data)
      pyextraction
        .post(bodyFormData, headers)
        .then(res => {
          console.info(res);
        })
        .catch(err => {
          console.log(err);
        });
    },

    async extractFramesFromVideo(videoUrl, newTime, fps = 1) {
      let self = this;
      // return new Promise(async (resolve) => {

      // fully download it first (no buffering):
      // let videoBlob = await fetch(videoUrl).then(r => r.blob());
      // let videoObjectUrl = URL.createObjectURL(videoBlob);


      let video = document.createElement("video");

      let seekResolve;
      video.addEventListener("seeked", async function() {
        if (seekResolve) seekResolve();
      });

      // video.src = videoObjectUrl;
      video.src = videoUrl;

      // workaround chromium metadata bug (https://stackoverflow.com/q/38062864/993683)
      while (
        (video.duration === Infinity || isNaN(video.duration)) &&
        video.readyState < 2
      ) {
        await new Promise(r => setTimeout(r, 1000));
        video.currentTime = 10000000 * Math.random();
      }
      let duration = video.duration;

      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let [w, h] = [video.videoWidth, video.videoHeight];
      canvas.width = w;
      canvas.height = h;

      let frames = [];
      let interval = 1 / fps;
      let currentTime = 0;
      // let ct = 0;

      while (currentTime < duration) {
        // console.log("i",this.i)
        video.currentTime = currentTime;
        await new Promise(r => (seekResolve = r));
        // video.crossOrigin = "Anonymous";

        // context.drawImage(video, 0, 0, 300, 300);
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        let base64ImageData = canvas.toDataURL();

        // var image = new Image();
        // image.id = "pic";
        // image.src = canvas.toDataURL();
        // document.getElementById('image_for_crop').appendChild(image);

        // console.log("hi")
        // console.log("old time:",newTime.format("dddd, MMMM Do YYYY, h:mm:ss:SSS a"))
        newTime.add(currentTime, "seconds");
        // console.log("new time:",newTime.format("dddd, MMMM Do YYYY, h:mm:ss:SSS a"))
        // console.log("newtime:",newTime.format('x'))
        // console.log("name",self.today1.format('x'))

        if(self.counter%5==0)
        {
          self.frames_counter+=1
          self.encrypt(self.id, newTime.format("x"), base64ImageData, Cookies.get('userId'));
        }
        
          
        
        // self.encrypt(self.id, newTime.format("x"), base64ImageData, Cookies.get('userId'));

        // self.encrypt(self.id, newTime.format("x"), base64ImageData, Cookies.get('userId'));
        // self.encrypt(self.id, self.tempName, base64ImageData)
        // self.encrypt(self.id, newTime.format('x'), canvas)

        // ct = currentTime

        // currentTime = ct + interval;
        // self.tempName += 1;
        currentTime += interval;
        self.counter+=1
        // console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++")
      }
      //     resolve(frames);
      // });
    },
    getJobDetails(userId){
      return new Promise((resolve, reject) => {
        jobdetails.get(userId).then((response) => {
          resolve(response)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    postJobDetails(userId){
      return new Promise((resolve, reject) => {
        jobdetails.get(userId).then((response) => {
          resolve(response)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getJobDetails(userId){
      return new Promise((resolve, reject) => {
        jobdetails.get(userId).then((response) => {
          resolve(response)
        }).catch((err) => {
          reject(err)
        })
      })
    }
  },
  async mounted() {
    let self = this;
    // console.log("====111========dasdasda=================");
    jobdetails
      .get(Cookies.get("userId"))
      .then(function(response) {
        // console.log(response.data.data)
        self.oldData = _.cloneDeep(response.data.data)
        self.data1 = response.data.data;
        // console.log(">>>>>>>>>>>>>>", self.data1.some(item => item.updatedAt === undefined))
        // console.log(">>>>>>>>>>>>>>>>>>>",self.data1[0]._id)
        if (self.data1.some(item => item.updatedAt === undefined)) {
          self.isClicked = false;
          self.id = self.data1[0]._id;
        } else {
          self.isClicked = true;
        }

        // console.log(response)
        // if(_.includes(response.data.data, 'updatedAt'))
        //     console.log("True")
        // else
        //     console.log("False")
        // response.data.data.forEach(function(item){
        //     console.log("hi",item)
        //     console.log("type:",typeof item)
        //     // item.includes("updatedAt")
        //     if(_.includes(item, "updatedAt"))
        //         console.log("True")
        //     else
        //         console.log("False")
        //     // if(item.includes("updatedAt"))
        //     //     console.log("True")
        //     // else
        //     //     console.lo("False")
        //     // if(item.some(item => item.updatedAt === undefined))
        //     //     console.log("True")
        //     // else
        //     //     console.log("False")

        // })
      })
      .catch(function(error) {
        console.log(error);
      });

      // try{
      //   let temp = await this.getJobDetails(Cookies.get("userId"))
      //   console.log(">>>>>>>>>>>>", temp)
      //   self.data1 = temp.data.data
      // }catch(err){
      //   console.log("Error:", err)
      // }

    window.crypto.subtle.generateKey(
        {
            name: "AES-CTR",
            length: 256, //can be  128, 192, or 256
        },
        true, //whether the key is extractable (i.e. can be used in exportKey)
        ["encrypt", "decrypt"] //can "encrypt", "decrypt", "wrapKey", or "unwrapKey"
    )
    .then(function(key){
        //returns a key object
        self.key = key
        console.log(key);
    })
    .catch(function(err){
        console.error(err);
    });

    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    self.browserName = navigator.appName;
    var fullVersion = "" + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera 15+, the true version is after "OPR/"
    if ((verOffset = nAgt.indexOf("OPR/")) != -1) {
      self.browserName = "Opera";
      fullVersion = nAgt.substring(verOffset + 4);
    }
    // In older Opera, the true version is after "Opera" or after "Version"
    else if ((verOffset = nAgt.indexOf("Opera")) != -1) {
      self.browserName = "Opera";
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf("Version")) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
      self.browserName = "Microsoft Internet Explorer";
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
      self.browserName = "Chrome";
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
      self.browserName = "Safari";
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf("Version")) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
      self.browserName = "Firefox";
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(" ") + 1) <
      (verOffset = nAgt.lastIndexOf("/"))
    ) {
      self.browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (self.browserName.toLowerCase() == self.browserName.toUpperCase()) {
        self.browserName = navigator.appName;
      }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt("" + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = "" + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod']

    if (macosPlatforms.indexOf(platform) !== -1) {
      self.operatingSystem = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      self.operatingSystem = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      self.operatingSystem = 'Windows';
    } else if (/Android/.test(userAgent)) {
      self.operatingSystem = 'Android';
    } else if (!self.operatingSystem && /Linux/.test(platform)) {
      self.operatingSystem = 'Linux';
    }

    

    // console.log(self.browserName);

    // console.log(navigator.)

    // document.write(''
    // +'Browser name  = '+self.browserName+'<br>'
    // +'Full version  = '+fullVersion+'<br>'
    // +'Major version = '+majorVersion+'<br>'
    // +'navigator.appName = '+navigator.appName+'<br>'
    // +'navigator.userAgent = '+navigator.userAgent+'<br>'
    // )

    // console.info("Vue is init");
  },
  feathers: {
    jobs: {
      created(data) {
        // console.log("====Created Data==:", data);
        // self.data1 = data;
      },
      updated(data) {
        console.log("====updated==", data);
        // self.data1 = data;
        // if (self.data1.some(item => item.updatedAt === undefined)) {
        //   self.isClicked = false;
        //   self.id = self.data1[0]._id;
        //   // console.log(self.id)
        // } else {
        //   self.isClicked = true;
        // }
      },
      removed(data) {
        console.log("====removed==", data);
        // self.data1 = data;
      }
    }
  }
};
</script>

<style>
html,
body {
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Arial,
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1em;
}
video {
  width: 30%;
  border-radius: 5px;
  border: 1px solid black;
}
</style>
